import { render, staticRenderFns } from "./storage_add.vue?vue&type=template&id=4ed3a0ef&scoped=true&"
import script from "./storage_add.vue?vue&type=script&lang=js&"
export * from "./storage_add.vue?vue&type=script&lang=js&"
import style0 from "./storage_add.vue?vue&type=style&index=0&id=4ed3a0ef&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed3a0ef",
  null
  
)

export default component.exports